import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { guardSurface } from '@/lib/platform/surfaces';
import type { AppEntry } from '@/app/routes-types';
import { ScheduleBoardPage } from '@/features/scheduled-buses/ScheduleBoardPage';
import { NotFoundPage } from '@/features/scheduled-buses/NotFoundPage';

export const entry: AppEntry = { byRole: {} };

const rootRoute = createRootRoute({ component: Outlet, notFoundComponent: NotFoundPage });

const boardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => guardSurface(entry, SURFACES['schedule-board']),
  component: ScheduleBoardPage,
  staticData: {
    title: 'Seattle Bus Times',
    page: SURFACES['schedule-board'],
    standalone: false,
    isPublic: true,
  },
});

export const router = createRouter({ routeTree: rootRoute.addChildren([boardRoute]) });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
